<template>
  <div
    v-shortkey="['ctrl', '/']"
    class="d-flex flex-grow-1"
    @shortkey="onKeyup"
  >
    <!-- Navigation -->
    <v-navigation-drawer
      v-model="drawer"
      app
      floating
      class="elevation-1"
      :right="$vuetify.rtl"
      :light="menuTheme === 'light'"
      :dark="menuTheme === 'dark'"
    >
      <!-- Navigation menu info -->
      <template v-slot:prepend>
        <div class="pa-2">
          <div class="title font-weight-bold text-uppercase primary--text">Aspire</div>
          <div class="overline grey--text"></div>
        </div>
      </template>

      <!-- Navigation menu -->
      <main-menu :menu="navigation.menu" />

      <!-- Navigation menu footer -->
      <template v-slot:append>
        <!-- Footer navigation links -->
        <div class="pa-1 text-center">
          <v-btn
            v-for="(item, index) in navigation.footer"
            :key="index"
            :href="item.href"
            :target="item.target"
            small
            text
          >
            {{ item.key ? $t(item.key) : item.text }}
          </v-btn>
        </div>

        <!-- REMOVE ME - Shop Demo purposes -->
        <div class="pa-2 pt-1 text-center">
          
        </div>
      </template>
    </v-navigation-drawer>


    <!-- Toolbar -->
    <v-app-bar
      app
      :color="isToolbarDetached ? 'surface' : undefined"
      :flat="isToolbarDetached"
      :light="toolbarTheme === 'light'"
      :dark="toolbarTheme === 'dark'"
    >
      <v-card class="flex-grow-1 d-flex" :class="[isToolbarDetached ? 'pa-1 mt-3 mx-1' : 'pa-0 ma-0']" :flat="!isToolbarDetached">
        <div class="d-flex flex-grow-1 align-center">

          <!-- search input mobile -->
          <v-text-field
            v-if="showSearch"
            append-icon="mdi-close"
            placeholder="Search"
            prepend-inner-icon="mdi-magnify"
            hide-details
            solo
            flat
            autofocus
            @click:append="showSearch = false"
          ></v-text-field>

          <div v-else class="d-flex flex-grow-1 align-center">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <v-spacer class="d-none d-lg-block"></v-spacer>

            <v-spacer class="d-block d-sm-none"></v-spacer>

            <v-btn class="d-block d-sm-none" icon @click="showSearch = true">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>

            
            <toolbar-details />

            <div :class="[$vuetify.rtl ? 'ml-1' : 'mr-1']">
              <toolbar-notifications />
            </div>

            <toolbar-user />
          </div>
        </div>
      </v-card>
    </v-app-bar>

    <v-main style="width:100%;padding: 56px 0px 27px;">
      <v-container class="fill-height" :fluid="!isContentBoxed">
        <v-layout>
           <router-view></router-view>
        </v-layout>
               
        
      </v-container>

    
    </v-main>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// navigation menu configurations
import config from '../configs'

import MainMenu from '../components/navigation/MainMenu'
import ToolbarUser from '../components/toolbar/ToolbarUser'
import ToolbarApps from '../components/toolbar/ToolbarApps'
import ToolbarDetails from '../components/toolbar/ToolbarDetails';
import ToolbarNotifications from '../components/toolbar/ToolbarNotifications'
import {PATH_LOGIN} from "@/data/pathData";
import { logout } from "@/api/auth";
export default {
  components: {
    MainMenu,
    ToolbarUser,
    ToolbarApps,
    ToolbarNotifications,
    ToolbarDetails
  },
  data() {
    return {
      drawer: null,
      showSearch: false,

      navigation: config.navigation
    }
  },
  computed: {
    ...mapState('app', ['product', 'isContentBoxed', 'menuTheme', 'toolbarTheme', 'isToolbarDetached'])
  },
  methods: {
    onKeyup(e) {
      this.$refs.search.focus()
    },
      async handleLogoutBtnClick() {
      let loader = this.$loading.show();
      try {
       //let response = await logout();
        loader.hide();
        // this.$store.dispatch("logout");
        // this.$store.dispatch("destroyUser");
        localStorage.removeItem('user');
        this.$router.push({path:"/login",
        query: {
      t: new Date().getTime(),
        }
    }
        );
      } catch (error) {
        loader.hide();
        // this.$store.dispatch("logout");
        // this.$store.dispatch("destroyUser");
        this.$router.push({path:"/login",
        query: {
      t: new Date().getTime(),
        }
    }
        );
        // this.$toast.error(error.response.data.message);
      }
    },
  }
}
</script>

<style scoped>
.buy-button {
  box-shadow: 1px 1px 18px #ee44aa;
}
</style>
